// src/components/ResetPassword.js
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [loading, setLoading] = useState(false);

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus({ type: 'danger', msg: 'Invalid reset link. Please request a new password reset.' });
    }
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', msg: '' });

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      setStatus({ type: 'danger', msg: 'Passwords do not match.' });
      return;
    }

    // Validate password strength
    if (formData.password.length < 6) {
      setStatus({ type: 'danger', msg: 'Password must be at least 6 characters long.' });
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
        { token, password: formData.password }
      );

      setStatus({ type: 'success', msg: data.message });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setStatus({
        type: 'danger',
        msg: err.response?.data?.error || 'Failed to reset password. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="row justify-content-center mt-5">
        <div className="col-md-6">
          <div className="card p-4 shadow-sm">
            <h2 className="mb-4 text-center">Invalid Reset Link</h2>
            <div className="alert alert-danger">
              {status.msg || 'Invalid reset link. Please request a new password reset.'}
            </div>
            <button 
              className="btn btn-primary w-100" 
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-md-6">
        <h2 className="mb-4 text-center">Reset Password</h2>
        {status.msg && (
          <div className={`alert alert-${status.type}`}>{status.msg}</div>
        )}
        <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              minLength="6"
            />
          </div>
          <button 
            type="submit" 
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword; 